var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNounCheck5958749(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m937.2 281.76c13.68 0 27.359 5.1602 37.801 15.602 20.879 20.879 20.879 54.602 0 75.48l-516.72 516.71-222.84-222.84c-20.879-20.879-20.879-54.602 0-75.48 10.441-10.441 24.121-15.602 37.801-15.602 13.68 0 27.359 5.1602 37.801 15.602l147.36 147.36 441.24-441.24c10.32-10.32 24-15.598 37.559-15.598m0-80.043c-35.641 0-69.121 13.922-94.32 39.121l-384.6 384.48-90.719-90.719c-25.199-25.199-58.68-39.121-94.32-39.121-35.641 0-69.121 13.922-94.32 39.121-52.078 52.078-52.078 136.68 0 188.76l279.48 279.48 573.36-573.36c52.078-52.078 52.078-136.68 0-188.76-25.32-25.203-58.801-39.004-94.562-39.004z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounCheck5958749);
export default __webpack_public_path__ + "static/media/noun-check-5958749.4c1f4939f285541e14b3c1f5d1311c1d.svg";
export { ForwardRef as ReactComponent };